<template>
  <v-autocomplete
    v-model="meetId"
    :hint="`${meetId}`"
    label="Select Meet Name"
    :items="
      getMeets.sort((a, b) => parseInt(b.meetId, 10) - parseInt(a.meetId, 10))
    "
    item-value="meetId"
    :item-text="meetText"
    dense
    :rules="requiredRule"
    hide-details
    outlined
    clearable
  >
  </v-autocomplete>
  <!--  CALL COMPONENT FROM PARENT EXAMPLE
              <AthletesDropdown v-on:change-athlete="onChangeAthlete"/>
              import AthletesDropdown from "../shared/athletes_dropdown_ex.vue";-->
</template>

<script>
import { mapGetters } from "vuex";
import { validation } from "../../mixins/validationMixin";

export default {
  mixins: [validation],
  props: {
    parentMeetId: {
      type: Number,
      default: 51
    },
    resultsBased: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      meetId: null
    };
  },
  computed: {
    ...mapGetters(["resultsList", "meets"]),
    getMeets: function() {
      // Get only list of meets which are linked to existing results
      if (
        this.meets.edges &&
        this.resultsList.length > 0 &&
        !this.resultsBased
      ) {
        return Array.from(
          new Set(this.resultsList.map(item => item.meetId))
        ).map(meetId => {
          let meetName = this.meets.edges.find(i => +i.node.meetId === +meetId);
          return {
            meetId: meetId,
            meetName: meetName ? meetName.node.meetName : "No data",
            meetDate: meetName ? meetName.node.meetDate : "No data"
            // .node.meetName.replace("Meet Results-", "")
          };
        });
        // Get all list of meets
      } else if (
        this.meets.edges &&
        this.resultsList.length > 0 &&
        this.resultsBased
      ) {
        // console.log(this.meets.edges.map(({ node, ...rest }) => ({ ...node, ...rest })) // remove node property
        //                        .sort((a, b) => parseInt(a.meetId, 10) - parseInt(b.meetId, 10))); // sort by meetId as number
        //
        return this.meets.edges.map(({ node, ...rest }) => ({
          ...node,
          ...rest
        })); // remove node property // sort by meetId as number
      } else return [];
    }
    // if(meetId) {
    //   meetId = this.parentMeetId;
    //   return meetId;
    // },
  },
  async created() {
    await this.$store.dispatch("allMeets");
    // await this.$store.dispatch("allResultsList", {
    //   clubId: this.$route.params.club ? this.$route.params.club : 1
    // });
    if (this.parentMeetId) {
      this.meetId = this.parentMeetId;
    }
    //take from route if it's not sent in parentMeetID
    if (!this.meetId && !(Object.entries(this.$route.query).length === 0)) {
      const { meetId } = this.$route.query;
      this.meetId = parseInt(meetId);
    }
    console.log(this.getMeets);
    console.log(this.meets.edges);
  },
  methods: {
    // Define the method that emits data to the parent as the first parameter to `$emit()`.
    // This is referenced in the <template> call in the parent. The second parameter is the payload.
    // emitToParent (eevnt) {

    //   this.$emit('childToParent', this.childMessage)
    // }
    meetText: item => item.meetName + " | " + item.meetDate + ""
  },

  watch: {
    meetId: function() {
      this.$emit("change-meet", this.meetId);
    }
  }
};
</script>
